import axios from "axios"
import { CreateToken } from "../config/CreateToken"

const apiUrl = process.env.REACT_APP_BASE_URL

// Common Controller Actions

export const fetchTotalLeads = async () => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchTotalLeads`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const fetchOverview = async () => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchOverview`
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const deleteAccount = async (data) => {
    try {
        await axios({
            'method': 'get',
            'url': `${apiUrl}/deleteAccount`,
            params: { data }
        })

        return {
            status: "success"
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const fetchLeads = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchLeads`,
            params: { token: CreateToken(data) }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "There is an error. Please refresh again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const fetchLeadsCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchLeadsCount`,
            params: { token: CreateToken(data) }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "There is an error. Please refresh again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const fetchLeadSteps = async () => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchLeadSteps`
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "There is an error. Please refresh again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const createLead = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/createLead`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "Incorrect details entered. Please try again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const fetchLeadDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchLeadDetails`,
            params: { token: CreateToken(data) }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const updateLeadsInfo = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/updateLeadsInfo`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "Incorrect details entered. Please try again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const updateLeadsInfoStatus = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/updateLeadsInfoStatus`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "Incorrect details entered. Please try again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const deleteLead = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/deleteLead`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        console.log("Server Response:", response)

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "Incorrect details entered. Please try again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const fetchUsers = async ({ page = 1, quantity = 10 } = {}) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/users?page=${page}&quantity=${quantity}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            data: response.data.data,
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "There is an error. Please refresh again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const fetchUsersCount = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchUsersCount`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            data: response.data.data,
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "There is an error. Please refresh again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const createNewUser = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/createNewUser`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "Incorrect details entered. Please try again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const fetchUserDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchUserDetails`,
            params: { token: CreateToken(data) }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const updateUsersInfo = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/updateUsersInfo`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "Incorrect details entered. Please try again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const deleteUser = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/deleteUser`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        console.log("Server Response:", response)

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "Incorrect details entered. Please try again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const clientFetchSupportLeads = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/clientFetchSupportLeads`,
            params: { token: CreateToken(data) }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "There is an error. Please refresh again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const clientPasswordChange = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/clientPasswordChange`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        if (err.response.status === "401") {
            return {
                status: "failed",
                message: "Authentication failed"
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status",
            message: err.message
        }
    }
}

export const clientFetchFAQ = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/clientFetchFAQ`,
            params: { token: CreateToken(data) }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "There is an error. Please refresh again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const clientFetchSupportDetails = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/clientFetchSupportDetails`,
            params: { token: CreateToken(data) }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "There is an error. Please refresh again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

export const deleteOtpSubmit = async (data) => {
    try {
        await axios({
            'method': 'get',
            'url': `${apiUrl}/deleteOtp`,
            params: { data }
        })

        return {
            status: "success"
        }
    } catch (err) {
        if (err.response.status == 401) {
            return {
                status: "failed",
                error: "Incorrect OTP entered. Please try again."
            }
        }
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching server status"
        }
    }
}

// Property Management Functions
export const getAllProperties = async ({
    page = 1,
    quantity = 10,
    status,
    developer,
    completionDate,
    propertyType,
    bedrooms,
    search
} = {}) => {
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            quantity: quantity.toString()
        });

        if (status && status !== 'all') params.append('status', status);
        if (developer && developer !== 'all') params.append('developer', developer);
        if (completionDate && completionDate !== 'all') params.append('completionDate', completionDate);
        if (propertyType && propertyType !== 'all') params.append('propertyType', propertyType);
        if (bedrooms && bedrooms !== 'all') params.append('bedrooms', bedrooms);
        if (search) params.append('search', search);

        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/properties?${params.toString()}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch properties"
        }
    }
}

export const getPropertiesCount = async (filters = {}) => {
    try {
        const params = new URLSearchParams();

        // Add all filter parameters exactly as they are (including 'all' values)
        if (filters.status) params.append('status', filters.status);
        if (filters.developer) params.append('developer', filters.developer);
        if (filters.completionDate) params.append('completionDate', filters.completionDate);
        if (filters.propertyType) params.append('propertyType', filters.propertyType);
        if (filters.bedrooms) params.append('bedrooms', filters.bedrooms);
        if (filters.search) params.append('search', filters.search);

        console.log('Getting count with params:', Object.fromEntries(params));

        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/countproperties?${params.toString()}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        console.error('Error fetching properties count:', err);
        return {
            status: "failed",
            error: "Failed to fetch properties count"
        }
    }
}

export const createProperty = async (formData) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/properties`,
            'data': formData,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'multipart/form-data'
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to create property"
        }
    }
}

export const updateProperty = async (formData) => {
    try {
        let response = await axios({
            'method': 'put',
            'url': `${apiUrl}/properties`,
            'data': formData,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'multipart/form-data'
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to update property"
        }
    }
}

export const deleteProperty = async (id) => {
    try {
        let response = await axios({
            'method': 'delete',
            'url': `${apiUrl}/properties/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success"
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to delete property"
        }
    }
}

//Team Member Management Functions
export const getAllTeamMembers = async ({ page = 1, quantity = 10 } = {}) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/teamMembers?page=${page}&quantity=${quantity}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch team members"
        }
    }
}

export const getTeamMembersCount = async (APIData) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/countTeamMembers`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch team members"
        }
    }
}

export const createTeamMember = async (formData) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/teamMembers`,
            'data': formData,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'multipart/form-data'
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to create team member"
        }
    }
}

export const updateTeamMembers = async (formData) => {
    try {
        let response = await axios({
            'method': 'put',
            'url': `${apiUrl}/teamMembers`,
            'data': formData,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'multipart/form-data'
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to update team member"
        }
    }
}

export const deleteTeamMember = async (id) => {
    try {
        let response = await axios({
            'method': 'delete',
            'url': `${apiUrl}/teamMembers/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success"
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to delete team member"
        }
    }
}

//Leads Management Functions
export const chatbotLeads = async ({ page = 1, quantity = 10 } = {}) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchChatbotLeads?page=${page}&quantity=${quantity}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch chatbot leads"
        }
    }
}

export const chatbotLeadsCount = async (APIData) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchChatbotLeadsCount`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch chatbot leads"
        }
    }
}

export const contactLeads = async ({ page = 1, quantity = 10 } = {}) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchContactLeads?page=${page}&quantity=${quantity}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch contact leads"
        }
    }
}

export const contactLeadsCount = async (APIData) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchContactLeadsCount`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch contact leada"
        }
    }
}

export const mortgageLeads = async ({ page = 1, quantity = 10 } = {}) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchMortgageLeads?page=${page}&quantity=${quantity}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch mortgage leads"
        }
    }
}

export const mortgageLeadsCount = async (APIData) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetchMortgageLeadsCount`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch mortgage leads"
        }
    }
}

// Advertisement Management Functions

// Get active advertisement settings (hero section)
export const getAdvertisement = async () => {
    try {
        let response = await axios({
            method: 'get',
            url: `${apiUrl}/advertisement/hero`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch advertisement settings"
        }
    }
}

// Get all advertisement settings history (admin only)
export const getAllAdvertisements = async () => {
    try {
        let response = await axios({
            method: 'get',
            url: `${apiUrl}/advertisement/hero/all`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch all advertisement settings"
        }
    }
}

// Create or update advertisement settings (hero section)
export const createAdvertisement = async (formData) => {
    try {
        let response = await axios({
            method: 'post',
            url: `${apiUrl}/advertisement/hero`,
            data: formData,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'multipart/form-data'
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to create advertisement"
        }
    }
}

// Update advertisement setting (if you need separate update endpoint)
export const updateAdvertisement = async (id, formData) => {
    try {
        let response = await axios({
            method: 'put',
            url: `${apiUrl}/advertisement/hero/${id}`,
            data: formData,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'multipart/form-data'
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to update advertisement"
        }
    }
}

// Delete advertisement setting (admin only)
export const deleteAdvertisement = async (id) => {
    try {
        let response = await axios({
            method: 'delete',
            url: `${apiUrl}/advertisement/hero/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to delete advertisement"
        }
    }
}

// Activate specific advertisement setting (admin only)
export const activateAdvertisement = async (id) => {
    try {
        let response = await axios({
            method: 'put',
            url: `${apiUrl}/advertisement/hero/${id}/activate`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to activate advertisement"
        }
    }
}

// Deactivate specific advertisement setting (admin only)
export const deactivateAdvertisement = async (id) => {
    try {
        let response = await axios({
            method: 'put',
            url: `${apiUrl}/advertisement/hero/${id}/deactivate`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to activate advertisement"
        }
    }
}

// Get combined advertisement and SEO data for frontend
export const getPublicAdvertisementData = async () => {
    try {
        let response = await axios({
            method: 'get',
            url: `${apiUrl}/public/advertisement/all`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch public advertisement data"
        }
    }
}

// Get advertisement by ID (if needed for specific operations)
export const getAdvertisementById = async (id) => {
    try {
        let response = await axios({
            method: 'get',
            url: `${apiUrl}/advertisement/hero/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to fetch advertisement"
        }
    }
}

// Download brochure file
export const downloadBrochure = async (filename) => {
    try {
        let response = await axios({
            method: 'get',
            url: `${apiUrl}/uploads/advertisement/${filename}`,
            responseType: 'blob'
        })
        return {
            status: "success",
            data: response.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Failed to download brochure"
        }
    }
}


//SEO Management Functions

// Get active SEO settings
export const getSEOSettings = async () => {
    try {
        let response = await axios({
            method: 'get',
            url: `${apiUrl}/advertisement/seo`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to fetch SEO settings"
        }
    }
}

// Create or update SEO settings
export const createSEOSettings = async (seoData) => {
    try {
        let response = await axios({
            method: 'post',
            url: `${apiUrl}/advertisement/seo`,
            data: seoData,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to save SEO settings"
        }
    }
}

// Get all SEO settings history
export const getAllSEOSettings = async () => {
    try {
        let response = await axios({
            method: 'get',
            url: `${apiUrl}/advertisement/seo/all`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to fetch SEO history"
        }
    }
}

// Delete SEO setting
export const deleteSEOSettings = async (id) => {
    try {
        let response = await axios({
            method: 'delete',
            url: `${apiUrl}/advertisement/seo/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to delete SEO settings"
        }
    }
}

// Activate specific SEO setting
export const activateSEOSettings = async (id) => {
    try {
        let response = await axios({
            method: 'put',
            url: `${apiUrl}/advertisement/seo/${id}/activate`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        return {
            status: "success",
            message: response.data.message
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Failed to activate SEO settings"
        }
    }
}